;(function() {
  'use strict'

  angular.module('core.services', [])
})()
